import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import { PrimaryButton, UIButton } from "components/ui";
import Classes, { StateTaxID } from "model";
import React from "react";
import MobileStateTaxIDTable from "./components/MobileStateTaxIDTable";
import StateTaxIDTable from "./components/StateTaxIDTable";

import "./styles.css";
import "./mobile.css";


/**
 * @function StateTaxIDPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StateTaxIDPage
 */
export default function StateTaxIDPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const updateStateTaxIDs = (type, value, stateTaxIDs, stateTaxID) => {
        let updatedStateTaxIDs = stateTaxIDs;

        if(type === "all") {
            updatedStateTaxIDs = stateTaxIDs.reduce((acc, item) => {
                const curr = StateTaxID.init({ ...item.record, isSelected: `${ value }` })
                acc.push(curr);
                return acc;
            }, []);
        } else {
            updatedStateTaxIDs = stateTaxIDs.reduce((acc, item) => {
                if(item.id === stateTaxID.id) {
                    const curr = StateTaxID.init({ ...item.record, isSelected: `${ value }` })
                    acc.push(curr);
                } else {
                    acc.push(item);
                }
                return acc;
            }, []);
        }

        return updatedStateTaxIDs;
    };

    const allRowsAreSelected = stateTaxIDs => {
        return stateTaxIDs.filter(item => item.isSelected !== "true").length === 0;
    };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        atLeastOneRowIsSelected: () => {
            return data.stateTaxIDs.filter(item => item.isSelected === "true").length > 0;
        },
 
        onDenyAllClick: val => {
            const updatedStateTaxIDs = updateStateTaxIDs("all", val, data.stateTaxIDs);
            const rowsAreSelected = allRowsAreSelected(updatedStateTaxIDs);

            BCMSStateManagerCRUD.init(state)
            .update([ "data", "stateTaxIDs" ], updatedStateTaxIDs)
            .update([ "data", "allRowsCheckboxIsSelected" ], rowsAreSelected)
            .submit(setState);
        },

        onRowClick: stateTaxID => val => {
            const updatedStateTaxIDs = updateStateTaxIDs("single", val, data.stateTaxIDs, stateTaxID);
            const rowsAreSelected = allRowsAreSelected(updatedStateTaxIDs);

            BCMSStateManagerCRUD.init(state)
            .update([ "data", "stateTaxIDs" ], updatedStateTaxIDs)
            .update([ "data", "allRowsCheckboxIsSelected" ], rowsAreSelected)
            .submit(setState);
        }
    });

    return (
        <PageContainer className="state-tax-id-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    )
}

export const getDefaultData = () => ({
    allRowsCheckboxIsSelected: false,
    stateTaxIDs: StateTaxID.initAll()
});

export const getDefaultUI = () => ({
// no ui changes for now
});

function PageContent(props) {
    const { data, atLeastOneRowIsSelected, onDenyAllClick, onRowClick } = useStateManager();
    const stateTaxIDs = data.stateTaxIDs ?? [];
    const allRowsCheckboxIsSelected = data.allRowsCheckboxIsSelected;

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="State Tax IDs" />

                <div className="show-on-desktop">
                    <StateTaxIDTable stateTaxIDs={ stateTaxIDs } allRowsCheckboxIsSelected={ allRowsCheckboxIsSelected }
                     onDenyAllClick={ onDenyAllClick } onRowClick={ onRowClick } />
                </div>
                <div className="show-on-mobile">
                    <MobileStateTaxIDTable stateTaxIDs={ stateTaxIDs } allRowsCheckboxIsSelected={ allRowsCheckboxIsSelected }
                     onDenyAllClick={ onDenyAllClick } onRowClick={ onRowClick } />
                </div>
                <div className="flex-container flex-horizontal align-center button-container">
                    <DisabledPrompt>
                        {/* Added "disabled-button" class to apply disabled styles. */}
                        <UIButton className={`delete-selected-button primary-button ${ atLeastOneRowIsSelected() ? "" : "disabled-button" }`} text="Delete Selected State Tax IDs" />
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <PrimaryButton text="Add State Tax ID" />
                    </DisabledPrompt>
                </div>
            </CenterContentContainer>
        </PageContentView>
    );
}
